export const DEFAULT_TIME_PERIOD = 'today'
export const DEFAULT_CHART_HEIGHT = 300
export const CHART_PRIMARY_COLOR = '#2563eb'
export const BREAKPOINT_SM = 640